import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import ContentLoader from "../../ContentLoader";
import { Request } from '../../../helpers/request'
import { getVariable } from '../../../helpers/variable'
import LocaleLink, { addLocalePrefix } from '../../Routes/LocaleLink'
import {FormattedMessage} from "react-intl";


class HomepageCooptation extends Component
{
    parallax = React.createRef();

    state = {
        variables: null
    };

    componentDidMount() {
        this.fetch();
        window.addEventListener('scroll', this.onScroll);
        this.onScroll()
    }

    fetch() {
        Request.get('variables/by-category/cooptation')
            .then((data) => {
                this.setState({ variables: data })
            })
            .catch(() => this.props.history.push(addLocalePrefix('/404')));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY;
        const delta = scrollY / this.parallax.current.offsetHeight;
        this.parallax.current.style.marginTop = Math.round(80 * delta - 420) + 'px'
    };

    render() {
        const hidden = (!this.state.variables || !this.state.variables.length);

        return (
            <section className="section-learn">
                <div className="section-learn-after" ref={this.parallax}/>
                {this.renderContent(hidden)}
            </section>
        )
    }

    renderContent(hidden) {
        if (hidden)
            return <ContentLoader/>;

        return (
            <div className="container">
                <div className="learn-block">
                    <div className="learn-head">
                        <h2>
                            { getVariable(this.state.variables, 'cooptation.title') }
                        </h2>
                        <span className='number-list p-0'>
                                <strong className='text-center m-0'>
                                   { getVariable(this.state.variables, 'cooptation.amount') }
                                </strong>
                            </span>
                    </div>
                    <h4>
                        <FormattedMessage
                            id="portfolio.homepage.cooptation.title"
                            defaultMessage="Nous vous offrons un bon d’achat Amazon de 500€ si votre connaissance est recrutée !"
                        />
                    </h4>
                    <p>
                        { getVariable(this.state.variables, 'cooptation.text') }
                    </p>
                    <LocaleLink to={"/cooptation"} className="btn btn-line-primary">
                        { getVariable(this.state.variables, 'cooptation.button') }
                    </LocaleLink>
                </div>
            </div>
        )
    }
}

export default withRouter(HomepageCooptation);
